<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title1"><h1 class="title"><strong class="b">Acknowledgments</strong></h1>
<p class="p"><span>The authors would like to thank the following individuals and organizations for their assistance in preparing this book: Paul Anselm (president, The Friends of The Ocean City Historical Museum), the staff of the Ocean City Historical Museum, John H. Andrus II (editor, <em class="i">Ocean City Sentinel-Ledger</em>), Tom Williams (sports columnist, <em class="i">Ocean City Sentinel-Ledger</em>), local historian Harold Lee, Heidi Cuppari, Martha and Tom Gibb, James Lee, Solin Lee, Sue Kasunich Matthews, Nancy Moore, Annetta Jeffries, Mark Soifer (director of public relations for the City of Ocean City), and author Gay Talese. Frederick Herrmann, Peter M. Kalellis, and John R. Taccarino provided guidance and encouragement for this project. Donald Lokuta of Kean College provided technical assistance, and Meg Eberhardt assisted in the preparation of the manuscript.</span></p>
<p class="p-indent"><span>The authors wish to thank Tara Esposito for her insightful comments and suggestions and Jamie Carter of Arcadia for her superb editorial assistance and support.</span></p>
<p class="p-indent"><span>We are also very appreciative of the historical background information provided by Doris and Robert Marts of Senior Studio, and their permission to use the marvelous photographs of Al Senior.</span></p></a></div><a id="title1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439632451_ack01.vue?f2aba91a